import { render, staticRenderFns } from "./DetailCoupon.vue?vue&type=template&id=8390f836&scoped=true&"
import script from "./DetailCoupon.vue?vue&type=script&lang=js&"
export * from "./DetailCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DetailCoupon.vue?vue&type=style&index=0&id=8390f836&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8390f836",
  null
  
)

export default component.exports